import { useEffect, useState } from 'react';
import { DropdownIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { setSportPinSort } from '@/hooks/query/use-bettype-pin';
import { useSingleMatchStore } from '@/store/singlematch';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';
import { useSingleMatchFilter } from '../../bet-types-section/contexts/single-match-filter-context';
import clsx from 'clsx';
import { Styles } from '@/features/single-match/bet-types-section/components/bet-type-header/bet-type-header.style';
import { timeMachineStyles } from '../time-machine.style';
import { useFirstRender, useThrottleClick } from '@nf/utils-common/hooks';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { PinButton } from '@/features/single-match/bet-types-section/components/pin-button';

type BetTypeHeaderProps = {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	children: React.ReactNode
};

export const TimeMachineHeader = ({
	setIsOpen,
	isOpen,
	children
}: BetTypeHeaderProps) => {
	const [betTypeSortSettings, setBetTypeSortSettings] = useSingleMatchStore(
		state => [state.betTypeSortSettings, state.setBetTypeSortSettings]
	);
	const [isPin, setIsPin] = useState(betTypeSortSettings.includes(228));
	const { isAllBetTypeCollapse } = useSingleMatchFilter();
	const t = useTranslations('General');
	const { filterSabaString } = useFilterSabaString();
	const timeMachinHeaderName = filterSabaString(t('lbl_SABATM'));
	const isFirstRender = useFirstRender();

	const handelPinClick = () => {
		setKafka();
		const betTypeId = 228;
		if (betTypeSortSettings.includes(betTypeId)) {
			setSportPinSort(1, betTypeSortSettings.filter((id) => id !== betTypeId));
			setBetTypeSortSettings(betTypeSortSettings.filter((id) => id !== betTypeId));
			setIsPin(false);
		} else {
			setSportPinSort(1, [betTypeId, ...betTypeSortSettings]);
			setBetTypeSortSettings([betTypeId, ...betTypeSortSettings]);
			setIsPin(true);
		}
	}

	const clickPin = useThrottleClick(handelPinClick);

	const setKafka = () => {
		const kafkaData = {
			note: KafkaNote.GalaxyV2,
			type: 9,
			action: 3
		}
		setKafkaNormal(kafkaData);
	}

	useEffect(() => {
		if (isFirstRender) return;
		setIsOpen(!isAllBetTypeCollapse);
	}, [isAllBetTypeCollapse]);

	return (
		<>
			<div
				className={clsx('bettype bettype--tm', Styles.bettype)}
				data-open={isOpen}
			>
				<div className={clsx('bettype__header', timeMachineStyles.header, Styles.bettypeHeader)} onClick={() => setIsOpen(!isOpen)}>
					<div className={clsx('bettype__header-text', Styles.bettypeHeaderText)}>{timeMachinHeaderName}</div>
					<div className="bettype__header-icons">
						<PinButton
							isActive={isPin}
							clickHandler={clickPin}
						/>
						<DropdownIcon />
					</div>
				</div>
				{children}
			</div>
		</>
	)
};
